<template>
<div id="pedimentos_referencias">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-flex xs12>
            <base-material-card color="primary" icon="library_books" title="Referencia Pedimento" class="elevation-1 px-5 py-3">
                <br />
                <v-tabs grow style="margin-bottom: 30px">
                    <v-tabs-slider color="primary"></v-tabs-slider>
                    <v-tab :key="'in-view'">Cargar Layout</v-tab>
                    <v-tab :key="'in-report'">Vista Previa</v-tab>
                    <v-tab-item :key="'in-view'">
                        <v-layout align-center justify-center>
                            <v-flex xs12>
                                <v-card class="elevation-1 px-5 py-3">
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <exportar-excel :data="representantes.camposLayout" :exportFields="representantes.encabezadoLayout" name="Layout Referencia Pedimento.xlsx">
                                            <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                                <v-icon dark>receipt</v-icon>
                                            </v-btn>
                                        </exportar-excel>
                                    </v-card-actions>
                                    <v-card-text>
                                        <v-card-text>
                                            <v-form ref="form" lazy-validation>
                                                <v-container grid-list-md>
                                                    <v-layout wrap>
                                                        <v-flex xs12>
                                                            <upload-excel-component2 :on-success="handleSuccess" :before-upload="beforeUpload" />
                                                        </v-flex>

                                                    </v-layout>
                                                </v-container>
                                            </v-form>
                                        </v-card-text>
                                    </v-card-text>

                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-tab-item>
                    <v-tab-item :key="'in-report'">
                        <v-card-text>
                            <v-card-title>
                                <span class="headline"></span>
                            </v-card-title>
                            <v-form ref="form1" lazy-validation>
                                <v-container grid-list-md text-xs-center>

                                    <v-row row wrap>
                                        <v-col sm="12" md="4" lg="4" >
                                            <v-autocomplete v-model="model.tipo_reporte" :items="tipos" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Filtrar Por" @change="clear_values()" :rules="[rules.required]" >
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="model.tipo_reporte==1" row wrap>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="
                                                                        model.fecha_de = parseDate(model.fecha_de)
                                                                        " v-mask="'####-##-##'" :rules="[
                                                                        rules.required,
                                                                        validaDias,
                                                                        validaFecha,
                                                                        ]">
                                                    </v-text-field>
                                                </template>

                                                <v-date-picker v-model="model.fecha_de" color="secondary" landscape scrollable locale="es-mx" @input="menu3 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu3 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[
                                                            rules.required,
                                                            validaDias,
                                                            validaFecha,
                                                            ]"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="model.fecha_a" color="secondary" landscape scrollable locale="es-mx" @input="menu4 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu4 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                         <v-col sm="12" md="2" lg="2">
                                            <v-radio-group v-model="model.fecha_factura" row>
                                                <v-radio label="Fecha de Carga" :value="false" ></v-radio>
                                                <v-radio label="Fecha de Emisión" :value="true" ></v-radio>
                                            </v-radio-group>                                         
                                        </v-col>  
                                        <v-col sm="12" md="2" lg="2">
                                             <v-btn rounded color="primary" @click="get_data_view()" :loading="loading">
                                                <v-icon>done</v-icon>Vista Previa
                                            </v-btn>
                                          </v-col>                                       
                                    </v-row>
                                    <v-row v-else>
                                        <v-col sm="2" >
                                            <v-btn icon title="Pegar Listado" @click="dialog1 = !dialog1" v-tippy>
                                            <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                                            </v-btn>
                                        </v-col>
                                        <v-col>
                                            Total de elementos en la lista: <strong>{{lista_filtrada.length}}</strong>
                                            </v-col>
                                    </v-row>
                                    <v-row v-if="model.tipo_reporte!=1" row wrap>
                                        <v-col sm="12" md="10" lg="10" >
                                        <v-combobox v-model="lista_filtrada" :label="model.tipo_reporte==2?'Lista de Pedimentos':(model.tipo_reporte==3?'Lista de Archivos':'Lista de UUIDs')" multiple persistent-hint small-chips disabled color="green" >
                                        </v-combobox>
                                        </v-col>
                                        <v-col sm="12" md="2" lg="2">
                                             <v-btn rounded color="primary" @click="get_data_view()" :loading="loading">
                                                <v-icon>done</v-icon>Vista Previa
                                            </v-btn>
                                          </v-col>
                                    </v-row>                                    

                                </v-container>
                            </v-form>
                    
                            <v-card>
                                <v-card-actions v-if="data_resumen.length>0">
                                    <v-spacer></v-spacer>
                                    <exportar-excel :data="datafiltered" :exportFields="data_resumen_excel" name="Resumen_Facturas_Transito.xlsx">
                                        <v-btn dark small color="success" title="Exportar Resumen" v-tippy>
                                            <v-icon dark>get_app</v-icon> Exportar a Excel
                                        </v-btn>
                                    </exportar-excel>

                                </v-card-actions>
                                <v-card-text>

                                    <v-client-table id="vuetabledetalle" ref="vuetabledetalle" :data="data_resumen" :columns="columns_resumen" :options="options_resumen" class="elevation-2 pa-2 scroll-table">
                                        <template slot="noResults">
                                            <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                        </template>
                                        
                                          <template slot="tipo_documento" slot-scope="props">
                                            <div style="display:flex; justify-content:center;">
                                               {{props.row.tipo_documento.substring(0, 25)}}
                                            </div>

                                        </template>
                                         <template slot="importe" slot-scope="props">
                                            <div style="display:flex; justify-content:right;">
                                               {{props.row.importe.toFixed(2)}}
                                            </div>

                                        </template>
                                    </v-client-table>
                                </v-card-text>
                            </v-card>
                        </v-card-text>
                    </v-tab-item>

                </v-tabs>

            </base-material-card>
        </v-flex>
        
    </v-container>

    <v-dialog v-model="dialog1" max-width="500px" >
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de {{model.tipo_reporte==2?'Pedimentos':(model.tipo_reporte==2?'Archivos':'UUIDs')}}</h5>
        <span>Uno por línea</span>
        <v-form ref="formListado" lazy-validation="" >
          <small><b>Consulta máxima de 50 lineas</b></small>
          <v-textarea outlined rows="15" v-model="model.lista" :rules="[rules.required, maxListaRule]" ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="model.lista='';dialog1 = false" >Cancelar</v-btn>
        <v-btn small color="primary" @click="setListValues();" >Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";

export default {
    components: {},

    data: () => ({
        dialog1:false,
        lista_filtrada: [],
        tipos: [{
            "id": 1,
            "text": "Por Fechas"
            }, {
            "id": 2,
            "text": "Por Lista de Pedimentos"
            }, {
            "id": 3,
            "text": "Por Lista de Nombre de Archivos"
            }, {
            "id": 4,
            "text": "Por Lista de UUIDs"
        }],
        clavesPedimentoArray: [],
        referencias: [],
        menu1: false,
        loading: true,
        show_loading: true,       
       
        columnsReferencias: [
            "referencia",
        ],
        optionsReferencias: {
            filterable: ["referencia"],
            sortable: ["referencia"],
            headings: {
                referencia: "Referencia",
            },
            headings: {
                referencia: "Planta/Referencia",
            },

        },
        data_resumen: [],
        data_resumen_excel: {
            Fecha: "fecha",
            Email: "email_usuario",
            Archivo: "filename",
            Folio: "folio",
            "Fecha Emisión": "fecha_emision",
            Metadato: "metadato",
            "Pedimento": "no_pedimento",
            "Fecha Pago":"fecha_pago",
            "Tipo de Documento": "tipo_documento"            

        },
        columns_resumen: [
            //  "id",
            "fecha",
            "iniciales",
            "filename",
            "folio",
            "fecha_emision",
            "importe",
            "metadato",
             "tipo_documento",
             "no_pedimento",
            "fecha_pago",
           
        ],
        options_resumen: {
            filterable: [
                "fecha",
                "iniciales",
                "filename",
                 "tipo_documento",
                "folio",
                "fecha_emision",
                "importe",
                "metadato",
                 "no_pedimento",
                "fecha_pago",
            ],
            orderBy: {
                column: 'fecha',
                ascending: false
            },
            sortable: [
                "fecha",
                "iniciales",
                "filename",
                 "tipo_documento",
                "folio",
                "fecha_emision",
                "importe",
                "metadato",
                 "no_pedimento",
                "fecha_pago",
            ],
            headings: {
                id: "",
                fecha: "Fecha",
                iniciales: "Usuario",
                filename: "Archivo",
                 tipo_documento: "Tipo de Documento",
                folio: "Folio",
                fecha_emision: "Fecha Emision",
                importe: "Importe",
                metadato: "Metadato",
                no_pedimento: "No. Pedimento",
                fecha_pago: "Fecha Pago",
            },
        },
        URL: "",

        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "eCosting",
                disabled: true,
                to: ""
            },
            {
                text: "Referencia Pedimento",
                disabled: true,
                to: ""
            }
        ],

        title: "",
        modal: false,
        update: false,
        pagination: {
            sortBy: "nombre"
        },
        search: "",
        model: {
            rfc: "",
            usuario: "",            
            fecha_de: "",
            fecha_a: "",
            tipo_reporte: 1,
            integrado:-1,//Para esta vista se necesita que muestre tanto integrados como no
            lista:"",
            lista_archivos:"",
            lista_pedimentos:"",
            lista_uuids:"",
            fecha_factura: false,
        },
       
        menu2: false,
        menu3: false,
        menu4: false,
        rules: {
            required: (v) => !!v || "Este campo es requerido",
            numeric: (value) => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            },
        },
        representantes: {
            selected: [],
            camposexcel: {
                Pedimento: "pedimento",
                "Año": "anio",
                "Referencia": "referencia",
            },
            items: [0],
            //En el encabezado deben ser iguales los pares, respetando el nombre del campo definido en el modelo de la API
            encabezadoLayout: {
                pedimento: "pedimento",
                anio: "anio",
                clave_pedimento: "clave_pedimento",
                archivo: "archivo",
            },
            //van vacíos para solo descargar layout con encabezados
            camposLayout: [{
                pedimento: "[No de Pedimento. Ej. 370-3668-9000123]",
                anio: "[Año del pedimento]",
                clave_pedimento: "[Clave del Pedimento]",
                archivo: "[Nombre del archivo con extensión, de la factura xml cargada]",
            }]
        },
        camposObligatorios: [
            "pedimento",
            "anio",
            "clave_pedimento",
            "archivo",
        ],
        estados: [],
        paises: [],
    }),
      computed: {
        datafiltered() {
            if (this.$refs['vuetabledetalle'] != null)
                return this.$refs.vuetabledetalle.allFilteredData;
            else
                return [];
        },
    },
    methods: {
        maxListaRule: function() {
            if (this.model.lista == '' || this.model.lista == undefined || Array.isArray(this.model.lista)) {
                return "Lista vacia";
            }

            let x = this.model.lista.split("\n");

            if (x.length > 50) {
                return "No se puede consultar mas de 50 pedimentos";
            }

            return true;
        },
        setListValues: function() {
            this.lista_filtrada = [];
            let to_list = this.get_array_lista(this.model.lista);
            for (var i = 0; i < to_list.length; i++) {
                if (this.lista_filtrada.includes(to_list[i])) {
                continue;
                } else {
                this.lista_filtrada.push(to_list[i]);
                }
            }
            this.dialog1 = !this.dialog1;
        },
        get_array_lista: function(cadena) {
            let data = cadena.split("\n");
            let newarr = data.filter(a => a.trim() !== '');
            for (var i = 0; i < newarr.length; i++) {
                newarr[i] = newarr[i].trim();
                newarr[i] = newarr[i].replace(',', '');                
            }

            return newarr;
        },
         validaFecha: function (fecha) {
            if (fecha == "Invalid date") return "Fecha no válida.";
            else return true;
        },
        validaAnio: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
            }
            return true;
        },
        validaDias: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
                if (Math.abs(diferencia) > 365)
                    return "Periodo máximo de consulta 365 dias. Favor de verificar.";
            }
            return true;
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();
                this.title = "Nuevo Representante Legal";
                this.update = false;
            } else {
                this.title = "Actualizar Representante Legal";
                this.update = true;
            }
            this.modal = true;
        },

        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }
            this.model.cliente = this.$local_storage.get("id_cliente");
        },

        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo debe ser menor a 2MB.",
                footer: ""
            });
            return false;
        },
        validarPatronPedimento(pedimento) {
            const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
            return patternPedimento.test(pedimento);
        },
        validaClavePedimento(referencia) {
            return this.clavesPedimentoArray.includes(referencia);
        },
        validaEntero(numero) {
            const pattern = /^[\d]*$/;
            return pattern.test(numero);
        },

        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }
            this.camposObligatorios.forEach(function (campo) {
                if (keys.indexOf(campo) == -1)
                    errores += '<br/>' + "- El campo '" + campo + "' es obligatorio.";
            });

            return errores == '' ? true : errores;
        },

        validaCargaLayout: async function (results) {
            var thisObject = this;
            //return new Promise(function(resolve, reject){
            var errores = 0;
            var erroresText = '';
            var errorTmp = '';
            try {
                if (results.length == 0) {
                    errores++;
                    erroresText += "No hay datos en el layout. Verifique que exista información a partir del 3er renglón.";
                } else if (results.length > 500) {
                    errores++;
                    erroresText += "El máximo de filas a procesar es 500, favor de verificar.";
                } else {
                    for (var k in results) {
                        results[k]["rfc"] = this.$local_storage.get("rfc");

                        var obligatorios = this.verificaObligatorios(results[k]);
                        if (obligatorios !== true) {
                            errores++;
                            if (erroresText.indexOf(obligatorios) == -1)
                                erroresText += obligatorios;
                        } else {

                            if (!this.validarPatronPedimento(results[k]['pedimento'])) {
                                errores++;
                                errorTmp = '<br/>' + "- El número '" + results[k]['pedimento'] + "' no es un pedimento válido. Ej. 240-1234-9000123";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if (!this.validaEntero(results[k]['anio'])) {
                                errores++;
                                errorTmp = '<br/>' + "- El número '" + results[k]['anio'] + "' no es un número entero válido.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            results[k]['archivo'] = results[k]['archivo'].toString().trim();
                            results[k]['clave_pedimento'] = results[k]['clave_pedimento'].toString().trim();
                            if (results[k]['clave_pedimento'] != "")
                                if (!this.validaClavePedimento(results[k]['clave_pedimento'])) {
                                    errores++;
                                    errorTmp = '<br/>' + "- La clave_pedimento '" + results[k]['clave_pedimento'] + "' no es válida, favor de revisar.";
                                    if (erroresText.indexOf(errorTmp) == -1)
                                        erroresText += errorTmp;
                                }

                        }
                        //console.log("Key is " + k + ", value is" + results[k]);
                    }

                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });

                
            }
            //}); //promise

        },
        handleSuccess: async function ({
            results,
            header
        }) {
            var errores = 0;
            var erroresText = '';
            this.importData = [];
            try {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    console.log(results);
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios.post(this.$hostname + "vucem/set_pedimento_factura/", results)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al guardar los datos. Favor de comunicarse con soporte.",
                                footer: ""
                            });
                        }).then(() => {
                            this.$root.$dialogLoader.hide();
                        });

                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        },
        get_data_view: function (opcion = 0) {
            if (!this.$refs.form1.validate() && opcion == 0) {
                //Opción sirve para saltar la validación cuando se busca por listado
                //Alguna operación o mensaje
            } else {
                var data = Vue.util.extend({}, this.model);;
                let selft = this;

                if (data.tipo_reporte != 1) {
                    if (data.lista == '' || data.lista == []) {
                        this.$swal({
                            type: "info",
                            title: "Información Faltante",
                            text: "Debe al menos ingresar un elemento a la lista",
                            footer: ""
                        });
                        return false;
                    }
                }
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                if (data.fecha_de == "") delete data["fecha_de"];
                if (data.fecha_a == "") delete data["fecha_a"];
                if (data.lista == '' || data.lista == []) {
                    delete(data['lista'])
                    delete(data['lista_pedimentos'])
                    delete(data['lista_archivos'])
                    delete(data['lista_uuids'])
                } else {
                    if (data.tipo_reporte == 2) {
                        data['lista_pedimentos'] = this.get_array_lista(data['lista']);
                        delete(data['lista_archivos'])
                        delete(data['lista_uuids'])
                        delete(data['lista'])
                    }else if (data.tipo_reporte == 3) {
                        data['lista_archivos'] = this.get_array_lista(data['lista']);
                        delete(data['lista_pedimentos'])                        
                        delete(data['lista_uuids'])
                        delete(data['lista'])
                    }else if (data.tipo_reporte == 4) {
                        data['lista_uuids'] = this.get_array_lista(data['lista']);
                        data['tipo_listado'] = "uuid";
                        delete(data['lista_pedimentos'])
                        delete(data['lista_archivos'])
                        delete(data['lista'])
                    }
                }                
                
                axios({
                        method: "post",
                        url:  "https://apireportes.econnectpro.mx/reportes/facturas_abiertas_xml/",                        
                        data: data,
                    })
                    .then((res) => {

                        this.data_resumen = res.data;
                        this.data_resumen.forEach(function (r) {
                            r.fecha = r.fecha.substring(0, 10);
                            if(r.fecha_emision != undefined)
                                r.fecha_emision = r.fecha_emision.substring(0, 10);

                            r.filename = r.filename + "." + r.ext;

                               if(r.tipo_documento != "No Localizado")
                              r.tipo_documento = r.tipo_documento + ' - '  + selft.getNombreTipoDocumento(r.tipo_documento);

                             if(r.tipo_documento == "null - ")
                                r.tipo_documento = "No Localizado";   

                             if(r.fecha_pago != undefined)
                                r.fecha_pago = r.fecha_pago.substring(0, 10);
                            
                            if(r.no_pedimento == "")
                                r.no_pedimento = "No Referenciado";
                        });
                        if (data.tipo_reporte != 1) {
                            this.model.lista = '';
                            this.model.lista_pedimentos = '';
                            this.model.lista_archivos = '';
                            this.model.lista_uuids = '';
                            this.lista_filtrada = [];
                        }
                        //console.log(res.data);
                        //console.log(res.data.resumen);
                    })
                    .catch((error) => {
                        console.log(error);
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener los registros. Intente nuevamente.",
                            footer: ""
                        });
                    })
                    .then(() => {
                        this.$root.$dialogLoader.hide();
                    });
            }
        },
      getNombreTipoDocumento: function (tipo) {
            var filtro = this.tiposDocumentos.filter(function (e) {
                return e.clave == tipo;
            });
            if (filtro.length > 0)
                return filtro[0].descripcion;
            else
                return '';
        },
            getTiposDocumentos: function () {

            var data = {
                tabla: 25,
            };
            axios.post(this.$hostname + "apendices/lista/", data)
                .then(response => {
                    if (response.data != undefined) {
                        this.tiposDocumentos = response.data;
                        this.tiposDocumentos = this.tiposDocumentos.sort(function (a, b) {
                            return a.clave > b.clave;
                        });
                        
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los tipos de documento.",
                        footer: ""
                    });
                });
        },
        cargarClavesPedimento: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .post(this.$hostname + "apendices/lista/", {
                    tabla: 13
                })
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        res.data.forEach(e => {
                            this.clavesPedimentoArray.push(e.clave);
                        })
                    } else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al apéndice de claves de pedimento",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el apéndice de claves de pedimento.",
                        footer: ""
                    });
                    console.log(err);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        deleteFile: function (id_archivo) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el archivo ?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var datos = {
                        id: id_archivo,
                    };
                    axios
                        .post(this.$hostname + "reportes/eliminar_factura_abierta_xml/", datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El archivo se eliminó correctamente",
                                footer: "",
                            });
                        })
                        .catch((error) => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el archivo. Favor de comunicarse con soporte.",
                                footer: "",
                            });
                            console.log(error);
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                            this.get_data_view()
                        });
                }
            });
        },
        async deleteFileAll(id_archivo) {
                    
                    var datos = {
                        id: id_archivo,
                    };
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    await axios
                        .post(this.$hostname + "reportes/eliminar_factura_abierta_xml/", datos)
                        .then((res) => {
                             this.$root.$dialogLoader.hide();
                        })
                        .catch((error) => {
                         
                            console.log(error);
                        });
               
        },
        deleteLista() {
            let self = this;
             this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar las facturas ?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    self.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    self.datafiltered.forEach(function(r){
                           self.deleteFileAll(r.id);
                    });
                    
                    self.$swal({
                                type: "success",
                                title: "¡Operación Realizada!",
                                text: "Se eliminarn los registros correctamente.",
                                footer: "",
                            }).then((result) => {
                        if (result.value) {
                            self.get_data_view();
                        }
                });
                            
                }
            });
            
            
        },
        clear_values() {
            this.model.lista = '';
            this.lista_filtrada = [];
            this.model.lista_pedimentos = '';
            this.model.lista_archivos = '';
            this.model.lista_uuids = '';
            this.model.fecha_de = '';
            this.model.fecha_a = '';            
        },
    }, //methods

    created: function () {
        this.cargarClavesPedimento();
         this.getTiposDocumentos();
        this.URL = this.$hostname + "reportes/";
        this.loading = false;
        this.model.usuario = this.$local_storage.get("id_usuario");
        this.model.rfc = this.$local_storage.get("rfc");
        if(this.$local_storage.get("trafico") == 1){
            this.breadcrumbs = [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home",
                },
                {
                    text: "E-Drive",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Facturas en Tránsito",
                    disabled: true,
                    to: "",
                },
            ];
        }
        
          var f = new Date();
         var f_de = new Date();

              f_de.setDate(f_de.getDate() + 1);

               

                let y_de = f_de.getFullYear();
                let m_de = f_de.getMonth() + 1;
                let d_de = f_de.getDate();

                if (m_de < 10)
                    m_de = '0' + m_de;
                if (d_de < 10)
                    d_de = '0' + d_de;

                let y = f.getFullYear();
                let m = f.getMonth() + 1;
                let d = f.getDate();

              
                if (m < 10)
                    m = '0' + m;
                if (d < 10)
                    d = '0' + d;
               

                this.model.fecha_de = y + "-" + m + "-" + d;
                this.model.fecha_a = y_de + "-" + m_de + "-" + d_de;
       
    }
};
</script>

<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #EEEEEE;
    padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;

}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}

.elevation-1 .v-expansion-panel>>>.v-label.theme--light {
    color: black !important;
}
</style>
